import { ItemData } from 'core/models/Template'

export const SMALL_BURGERS_CATALOG_TYPE = 'small_burgers' as const
export const SMALL_BURGERS_CATALOG_TITLE_KEY = 'smallBurgersCatalog' as const

export const SMALL_BURGERS_CATALOG_CONFIG = {
    type: SMALL_BURGERS_CATALOG_TYPE,
    additionalData: {},
} as const

export type SmallBurgersSelectedItems = ItemData[]
